import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { statusIcons } from './assets/status-icons';

export const DS_ALERT_TYPE_ARRAY = ['success', 'error', 'caution', 'info'] as const;
export type DsAlertType = (typeof DS_ALERT_TYPE_ARRAY)[number];

@Component({
    selector: 'ds-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [CommonModule],
    host: {
        'class': 'ds-alert',
        '[class]': 'hostClass()',
        '[class.ds-alert-inverse]': 'inverse()',
        '[attr.role]': 'role()',
        '[attr.aria-atomic]': '"true"',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsAlert {
    private readonly _sanitizer = inject(DomSanitizer);
    readonly type = input<DsAlertType>('success');
    readonly inverse = input(false, { transform: booleanAttribute });
    readonly politeness = input<'polite' | 'assertive'>('assertive');

    role = computed(() => (this.politeness() === 'assertive' ? 'alert' : 'status'));
    protected svg = computed(() => {
        const rawSvg = statusIcons[this.type()];
        return rawSvg ? this._sanitizer.bypassSecurityTrustHtml(rawSvg) : '';
    });
    readonly hostClass = computed(() => `ds-alert-${this.type()}`);
}
